export default {"src":"/_next/static/media/application-integrity.7938622d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};